import React, { useState } from "react";
import { generateOTP } from "../../services/patientRegistrationRequesApi";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { showToast } from "../../utils/toastUtils";
import { sendOtp } from "../../../clinic/services/authApi";

const OtpSection = () => {
  const location = useLocation();
  const history = useNavigate();
  const { url = "/patient/familylist", ...restData } = location?.state ?? {};
  const [contactNumber, setContactNumber] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleContactNumberChange = (event) => {
    const input = event.target.value;
    if (input === "" || (isNumeric(input) && input.length <= 10)) {
      setContactNumber(input);
    }
  };

  const phoneRegex = /^[1-9]\d{9}$/;

  const isValidPhoneNumber = (number) => {
    return phoneRegex.test(number);
  };

  const isNumeric = (value) => {
    return /^\d+$/.test(value);
  };

  const handleSendOtp = async () => {
    if (!isValidPhoneNumber(contactNumber)) {
      setErrorMessage(
        "Please enter a valid 10 digit phone number"
      );
      return;
    }

    setErrorMessage("");

    try {
      const response = await sendOtp(contactNumber);
      if (response?.status) {
        showToast("OTP sent successfully", "success");
        await localStorage.setItem("number", contactNumber);
        setTimeout(() => {
          history("/patient/verification/otp", {
            state: { url, contactNumber, ...restData },
          });
        }, 1000);

      } else {
        console.error("Error sending OTP");
        setErrorMessage("Error in sending OTP. Please try again.");
      }
    } catch (error) {
      console.error("Network error:", error);
      setErrorMessage("Network error. Please try again.");
    }
  };

  return (
    <div className="flex flex-col lg:justify-center items-center bg-[#f2f9ff] pt-5 xl:pt-0 justify-center min-h-[calc(100vh-0px)] w-full">
      <div className=" py-5">
        <img
          src="../images/new_vitalX_logo.svg"
          className=" h-36 mx-auto "
          alt=""
        />
      </div>
      <div className="w-full md:w-8/12 lg:w-6/12 xl:w-4/12  px-5 md:px-3 xl:px-0">
        <div className="md:bg-white md:shadow-sm md:px-5 py-5 lg:px-14 lg:py-12 rounded-2xl">
          <div className="mb-8">
            <h3 className="mb-1 text-xl font-bold text-[#04225b]">
              Hello Patient
            </h3>
          </div>
          <div className="inline-flex flex-col w-full relative mb-6">
            <label
              htmlFor="contactNumber"
              className="mb-1 text-gray-800 bg-[#f2f9ff] md:bg-white font-semibold text-[14px]"
            >
              Phone Number
            </label>
            <input
              id="contactNumber"
              value={contactNumber}
              type="text"
              onChange={handleContactNumberChange}
              className="min-h-[45px] w-full px-5 outline-none border-2  bg-[#f2f9ff] md:bg-white border-gray-200 rounded-md focus:ring-[#0188fc] focus:border-[#0188fc]"
            />
          </div>
          <button
            type="submit"
            onClick={handleSendOtp}
            className="min-w-[131px] w-full text-base font-medium rounded-lg py-2 px-5 bg-[#0188fc] hover:bg-[#076ec7] text-white"
          >
            Send OTP
          </button>

          <ToastContainer />

          <div className=" text-red-500">{errorMessage}</div>
        </div>
      </div>
    </div>
  );
};

export default OtpSection;
